<template>
  <div class="eb-status" :class="getClassName()"></div>
</template>

<script setup>
const props = defineProps(['status'])

function getClassName() {
  const statusMap = {
    '0': 'enable',
    '1': 'disabled'
  }
  return statusMap[props.status] || ''
}
</script>

<style lang='scss' scoped>
.eb-status {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #000;
  border-radius: 50%;
  margin-right: 8px;

  &.enable {
    background-color: #69C242;
  }

  &.disabled {
    background-color: #F36B6E;
  }
}
</style>
